// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { Project } from "../../types";

const projectsModule = {
  async findByUserId(userId: string): Promise<Project[]> {
    try {
      const result = await sql`
        SELECT * FROM projects
        WHERE user_id = ${userId}
        ORDER BY position ASC, created_at DESC
      `;
      return (result || []) as Project[];
    } catch (error) {
      console.error('Error fetching projects:', error);
      return [];
    }
  },
  
  async findById(id: string, userId: string): Promise<Project | null> {
    try {
      const result = await sql`
        SELECT * FROM projects
        WHERE id = ${id} AND user_id = ${userId}
        LIMIT 1
      `;
      return result[0] as Project || null;
    } catch (error) {
      console.error('Error fetching project:', error);
      return null;
    }
  },
  
  async create(data: Omit<Project, 'id' | 'created_at' | 'updated_at'>): Promise<Project> {
    const result = await sql`
      INSERT INTO projects (user_id, title, description, status, position, client_id, start_date, deadline)
      VALUES (${data.user_id}, ${data.title}, ${data.description}, 
              ${data.status || 'Active'}, ${data.position}, ${data.client_id},
              ${data.start_date}, ${data.deadline})
      RETURNING *
    `;
    return result[0] as Project;
  },
  
  async update(id: string, userId: string, data: Partial<Project>): Promise<Project> {
    const result = await sql`
      UPDATE projects
      SET title = COALESCE(${data.title}, title),
          description = COALESCE(${data.description}, description),
          status = COALESCE(${data.status}, status),
          position = COALESCE(${data.position}, position),
          client_id = CASE WHEN ${data.client_id === undefined} THEN client_id ELSE ${data.client_id} END,
          start_date = CASE WHEN ${data.start_date === undefined} THEN start_date ELSE ${data.start_date} END,
          deadline = CASE WHEN ${data.deadline === undefined} THEN deadline ELSE ${data.deadline} END,
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as Project;
  },
  
  async markComplete(id: string, userId: string): Promise<Project> {
    const result = await sql`
      UPDATE projects
      SET is_complete = true,
          completed_at = now(),
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as Project;
  },
  
  async markIncomplete(id: string, userId: string): Promise<Project> {
    const result = await sql`
      UPDATE projects
      SET is_complete = false,
          completed_at = NULL,
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as Project;
  },
  
  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM projects
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count > 0;
  }
};

export type ProjectsModule = typeof projectsModule;

export function registerProjects(db: { projects?: ProjectsModule }) {
  db.projects = projectsModule;
}

export { projectsModule as projects };
